import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { ServiceCategory } from "@/types/serviceCategory";
import { ServiceCategoryForm } from "./ServiceCategoryForm";

interface ServiceCategoryDialogProps {
    children: React.ReactNode;
    category?: ServiceCategory;
}

export const ServiceCategoryDialog: React.FC<ServiceCategoryDialogProps> = ({
    children,
    category,
}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>
                        {category
                            ? t("services.categories.dialog.editTitle", "Edit Category")
                            : t("services.categories.dialog.createTitle", "Create Category")}
                    </DialogTitle>
                </DialogHeader>
                <ServiceCategoryForm
                    category={category}
                    onSuccess={() => setOpen(false)}
                    onCancel={() => setOpen(false)}
                />
            </DialogContent>
        </Dialog>
    );
};
